import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from "react-native"


import tw from '../../styles/tailwind';
import Text from '../../components/Text';


import { StyleSheet } from 'react-native';
import AppIntroSlider from 'react-native-app-intro-slider';
import { Image } from 'expo-image';
import { SafeAreaView } from 'react-native-safe-area-context';
import DDCircle from '../../assets/images/svgs/dd_circle'




export default function WelcomeWizard({ onDone }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      key: 'somethun',
      text: 'Notificaciones y recordatorios de tus cuotas por pagar.',
      // text: 'Description.\nSay something cool',
      image: require('./slide_1.png'),
      backgroundColor: '#59b2ab',
    },
    {
      key: 'somethun-dos',
      text: 'Crea accesos de tus inquilinos, invitados y proveedores',
      // text: 'Other cool stuff',
      image: require('./slide_2.png'),
      backgroundColor: '#febe29',
    },
    {
      key: 'somethun1',
      // title: 'Rocket guy',
      text: 'Mantente al día de los eventos y actividades de tu fraccionamiento',
      image: require('./slide_3.png'),
      backgroundColor: '#22bcb5',
    }
  ];

  const _renderItem = ({item}) => {
    return (
      <View style={tw`h-100% pb-20 justify-around`}>
        {
          item.title &&
            <Text style={tw`px-8 text-center text-2xl font-500 text-[#318f88]`}>{item.title}</Text>
        }

        <Image source={item.image} style={tw`h-140 -my-20`} contentFit='cover' />

        {
          item.text &&
            <Text style={tw`px-8 text-center text-xl font-500 text-[#318f88]`}>{item.text}</Text>
        }
        {/* <Text style={tw``}>{item.text}</Text> */}
      </View>
    );
  }
  const _onDone = () => {
    // User finished the introduction. Show real app through
    // navigation or simply by controlling state
    // this.setState({ showRealApp: true });
  }
  return (
    <SafeAreaView style={tw.style('absolute top-0 bottom-0 left-0 right-0 bg-[#e5f8f5]')}>
      <View
        style={tw.style(
          `absolute -top-80 h-100%`,
          currentSlide == 0 && `left-0 -right-100`, 
          currentSlide == 1 && `left-0 right-0`, 
          currentSlide == 2 && `-left-100 right-0`, 
        )}
      >
        <DDCircle fill="#d4f7f4" />
        {/* d4f7f4 */}
      </View>

      <AppIntroSlider
        renderItem={_renderItem}
        data={slides}// sin esto da error?
        slides={slides}
        onDone={onDone}
        bottomButton
        hidePagination={true}
        dotStyle={{height:0}}
        activeDotStyle={{height:0}}
        onSlideChange={(index) => setCurrentSlide(index)}
        renderNextButton={() => 
          <View style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}>
            <Text style={tw`text-white text-lg font-600`}>Siguiente</Text>
          </View>
        }
        renderDoneButton={() => 
          <View style={tw`bg-primary py-4 items-center self-center rounded-full w-90%`}>
            <Text style={tw`text-white text-lg font-600`}>Empezar</Text>
          </View>
        }
      />
    </SafeAreaView>
  )
}

